import axiosInstance from "../api/axios";

export async function getComments(id: string) {
    try {
        const response = await axiosInstance.get(`/comments/${id}`)

        return response.data;
    } catch (e: any) {
        throw new Error(e);
    }
}

export async function addComment(data: any) {
    try {
        const response = await axiosInstance.post(`/comments`, data)

        return response.data;
    } catch (e: any) {
        throw new Error(e);
    }
}

export async function likeComment(id: string) {
    try {
        const response = await axiosInstance.get(`/comments/${id}/like`)

        return response.data;
    } catch (e: any) {
        throw new Error(e);
    }
}
